import { styled, Typography } from "@mui/material";
import { StyleguideSavioFonts } from "../configuration/themeSettings";

export const ContainerErrorStyled = styled("div", { label: "AppRoute-ContainerErrorStyled" })(
    ({ theme }) => ({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        color: theme.palette.primary.main,
        ">p": {
            fontSize: 35,
        }
    })
);

export const Text = styled(Typography, { label: "AppRoute-Text" })(
    ({ theme: Theme }) => ({
        fontSize: 70,
        fontWeight: StyleguideSavioFonts.bold,
        textTransform: "uppercase",
    })
);